{
  "title": "Новый сервер",
  "intro": "Выберите, где сервер будет работать, с какой системой и сколько ресурсов ему нужно. В сводке — что выбрано и сколько это стоит. Настройка сохраняется в адресе страницы: ссылкой можно поделиться или вернуться к ней позже.",
  "create": "Создать сервер",
  "createMany": "Создать серверы: {{count}}",
  "createShort": "Создать",
  "blocked": "Чтобы создать, исправьте: {{sections}}.",
  "started": "Создаём сервер «{{name}}». Обычно это занимает меньше минуты.",
  "startedMany": "Создаём серверы: {{count}}. Обычно это занимает меньше минуты.",
  "partial": "Не созданы: {{names}}. {{reason}}",
  "perHour": "в час",
  "perMonth": "в месяц",
  "free": "{{names}} (бесплатно)",
  "arch": {
    "x86": "x86 (Intel, AMD)",
    "arm": "Arm64 (Ampere)"
  },
  "region": {
    "title": "Регион",
    "intro": "Где физически будет стоять сервер. Ближе к пользователям — быстрее ответы. Регион потом не поменять: только пересоздать сервер.",
    "zone": "Сетевая зона {{zone}}",
    "offered": "типов серверов: {{count}}",
    "typeMissing": "Тип {{type}} здесь не предлагается"
  },
  "image": {
    "title": "Образ",
    "intro": "С чего сервер начнёт работу: операционная система или готовое приложение. Показаны образы для архитектуры {{arch}}.",
    "os": "Операционные системы",
    "apps": "Приложения",
    "version": "Версия {{os}}",
    "noApps": "Для этой архитектуры провайдер сейчас не предлагает готовых приложений. Выберите операционную систему и установите нужное сами или через cloud-init.",
    "appOn": "На базе {{os}}",
    "rapidDeployHint": "Образ заранее подготовлен у провайдера, поэтому сервер с ним запускается быстрее.",
    "unknown": "Этого образа нет в каталоге проекта. Выберите другой.",
    "wrongArch": "У образа «{{image}}» нет версии для {{arch}}. Выберите другую систему или тип сервера другой архитектуры.",
    "own": "Снимки и копии",
    "noOwn": "В проекте нет снимков и резервных копий. Их можно сделать на странице сервера.",
    "ownSnapshot": "Снимок · {{os}} · {{arch}} · диск от {{disk}}\u00a0ГБ · {{date}}",
    "ownBackup": "Резервная копия · {{os}} · {{arch}} · диск от {{disk}}\u00a0ГБ · {{date}}",
    "ownGone": "Этой копии больше нет. Выберите другую или операционную систему.",
    "ownNotReady": "Копия «{{name}}» ещё создаётся.",
    "ownTooLarge": "Копии нужен диск от {{disk}}\u00a0ГБ, а у {{type}} — {{typeDisk}}\u00a0ГБ. Выберите тип с диском побольше."
  },
  "type": {
    "title": "Тип сервера",
    "intro": "Сколько у сервера процессоров, памяти и диска. Оплата почасовая, но за месяц не больше указанной суммы. Тип можно увеличить позже.",
    "hint": "Общие vCPU делят физические ядра с соседями и дешевле; выделенные закреплены за вашим сервером — для постоянной нагрузки. Трафик — исходящий, входящий бесплатен.",
    "sort": "Сортировка",
    "sorts": {
      "price": "Сначала дешёвые",
      "cores": "По числу vCPU",
      "memory": "По объёму памяти",
      "disk": "По объёму диска"
    },
    "noneHere": "В регионе {{region}} нет типов с такими фильтрами. Смените архитектуру, семейство или регион.",
    "missing": "В регионе {{region}} не предлагаются: {{types}}. Чтобы выбрать их, смените регион.",
    "value": "{{type}}: {{cores}}\u00a0vCPU, {{memory}}\u00a0ГБ RAM, {{disk}}\u00a0ГБ",
    "memoryValue": "{{gb}}\u00a0ГБ RAM",
    "diskValue": "{{gb}}\u00a0ГБ"
  },
  "networking": {
    "title": "Сеть",
    "intro": "Публичные адреса, по которым сервер доступен из интернета. Их можно добавить или убрать позже, когда сервер выключен.",
    "hint": "Адреса создаются вместе с сервером и по умолчанию удаляются вместе с ним. Их можно сохранить и переназначить на странице «IP-адреса».",
    "ipv4": "Публичный IPv4",
    "ipv4Price": "{{price}} в месяц, оплачивается отдельно от сервера.",
    "ipv4Paid": "Оплачивается отдельно от сервера.",
    "ipv6": "Публичный IPv6",
    "ipv6Free": "Сеть /64, бесплатно.",
    "ipv6Only": "Только IPv6: часть сайтов и сервисов (например, некоторые репозитории пакетов) по IPv6 недоступны, и вы не подключитесь к серверу из сети без IPv6.",
    "none": "Без публичных адресов и без частной сети к серверу никак не подключиться. Оставьте IPv4 или IPv6 или выберите частную сеть ниже.",
    "noneShort": "Без публичных адресов",
    "privateOnly": "Без публичных адресов сервер доступен только из выбранных частных сетей. Сам он тоже не выйдет в интернет (например, за обновлениями), если другой сервер сети не будет пересылать его трафик."
  },
  "networks": {
    "title": "Частные сети",
    "intro": "Серверы одной частной сети общаются по внутренним адресам, минуя интернет. Необязательно, бесплатно.",
    "hint": "Сеть работает в сетевых зонах. Сервер можно подключить, если у сети есть подсеть в зоне его региона; адрес он получит из этой подсети.",
    "subnet": "{{range}}: адрес из {{subnet}} ({{zone}})",
    "otherZone": "Нет подсети в зоне {{zone}}, где находится регион. Добавьте её на странице сети или выберите регион в другой зоне.",
    "empty": "В проекте пока нет частных сетей.",
    "noneFits": "Ни у одной сети проекта нет подсети в зоне {{zone}}.",
    "create": "Создать сеть",
    "none": "Нет"
  },
  "firewalls": {
    "title": "Файрволы",
    "intro": "Правила, какой трафик пропускать к серверу; действуют с первого запуска. Необязательно, бесплатно.",
    "hint": "Файрвол только разрешает: когда он применён, всё, что не разрешено его правилами, отбрасывается. Правила нескольких файрволов складываются.",
    "rules": "Входящих правил: {{in}}, исходящих: {{out}}",
    "empty": "В проекте пока нет файрволов.",
    "open": "Файрвол не выбран: все порты сервера открыты из интернета. Применить файрвол можно и позже.",
    "create": "Создать файрвол",
    "none": "Нет, все порты открыты"
  },
  "keys": {
    "title": "SSH-ключи",
    "intro": "Ключи, с которыми можно войти на сервер как root. Это надёжнее пароля: ключ нельзя подобрать.",
    "none": "Ключ не выбран: провайдер сгенерирует пароль root. Мы покажем его один раз сразу после создания и нигде не сохраним.",
    "passwordShort": "Пароль root, будет показан один раз"
  },
  "backups": {
    "title": "Резервные копии",
    "intro": "Провайдер раз в сутки копирует весь диск сервера и хранит семь последних копий. Из копии можно восстановить сервер или создать новый.",
    "enable": "Включить ежедневные копии",
    "price": "+{{percent}}\u00a0% к цене сервера: {{price}} в месяц.",
    "percent": "+{{percent}}\u00a0% к цене сервера.",
    "on": "Ежедневно",
    "off": "Выключены"
  },
  "terminal": {
    "title": "Терминал в браузере",
    "intro": "Сервер с первой загрузки доверяет центру сертификации SSH вашей организации: терминал в панели входит на него по одноразовым сертификатам, без ваших ключей и паролей.",
    "enable": "Терминал в браузере",
    "hint": "Добавляет к cloud-init несколько строк: ключ центра сертификации в /etc/ssh и строку TrustedUserCAKeys в настройках sshd. Ваши SSH-ключи и пароль root работают как прежде.",
    "on": "Включён",
    "off": "Выключен"
  },
  "labels": {
    "title": "Метки",
    "intro": "Пары «ключ — значение», чтобы находить и группировать серверы, например env=production. Необязательно.",
    "hint": "Ключ и значение — до 63 символов: латинские буквы и цифры по краям, внутри ещё «-», «_» и «.». Значение можно не заполнять.",
    "key": "Ключ",
    "value": "Значение",
    "add": "Добавить метку",
    "remove": "Убрать метку {{key}}",
    "none": "Нет",
    "problems": {
      "keyMissing": "Укажите ключ.",
      "keyInvalid": "Ключ: до 63 символов, латинские буквы и цифры по краям, внутри ещё «-», «_» и «.».",
      "valueInvalid": "Значение: до 63 символов, латинские буквы и цифры по краям, внутри ещё «-», «_» и «.».",
      "duplicate": "Такой ключ уже есть."
    }
  },
  "autopilot": {
    "title": "Автопилот",
    "intro": "Агент мониторинга установится при первом запуске сервера: метрики, сервисы, контейнеры и предупреждения появятся на странице сервера. Бесплатно.",
    "enable": "Включить Автопилот",
    "enableHint": "CloudServer добавит установку агента в cloud-init сервера. Агент только смотрит и предупреждает: ничего на сервере не меняет и не обновляет.",
    "on": "Включён (бесплатно)",
    "onNoContainers": "Включён, без контейнеров (бесплатно)",
    "off": "Выключен",
    "role": "Роль агента",
    "roleHint": "Что ИИ-ассистент может делать на сервере кроме мониторинга."
  },
  "userData": {
    "title": "Cloud-init",
    "intro": "Скрипт или конфигурация, которую сервер выполнит при первом запуске: установить пакеты, создать пользователей, записать файлы. Необязательно.",
    "label": "Данные пользователя (user data)",
    "hint": "Использовано {{used}} из {{max}}\u00a0КБ. Начните с #cloud-config или со строки #!/bin/bash.",
    "why": "Cloud-init читает эти данные только при первом запуске. Не храните здесь пароли: данные видны на самом сервере.",
    "tooLarge": "Больше 32\u00a0КБ — провайдер такое не примет. Сократите или загружайте крупные файлы скриптом.",
    "set": "Задан",
    "none": "Нет"
  },
  "name": {
    "title": "Имя",
    "intro": "Имя сервера в проекте; оно же станет именем хоста в системе. Мы предложили имя по системе, типу и региону.",
    "label": "Имя сервера",
    "baseLabel": "Начало имён",
    "hint": "Латинские буквы, цифры и дефисы, можно через точку (как имя хоста). Без пробелов и подчёркиваний.",
    "why": "Имя должно быть уникальным в проекте. Его видно в списке серверов и в приглашении командной строки.",
    "useSuggested": "Вернуть предложенное: {{name}}",
    "preview": "Будут созданы: {{names}}",
    "problems": {
      "invalid": "Так назвать нельзя: только латинские буквы, цифры и дефисы, без дефиса в начале и в конце части.",
      "tooLong": "Слишком длинное имя: вместе с номером не больше 253 символов.",
      "taken": "Сервер с таким именем в проекте уже есть."
    }
  },
  "count": {
    "title": "Количество",
    "intro": "Сколько одинаковых серверов создать, до {{max}} за раз. Имена получат номера -1, -2 и так далее.",
    "label": "Количество серверов",
    "less": "Меньше",
    "more": "Больше",
    "value": "Серверов: {{count}}"
  },
  "summary": {
    "title": "Сводка",
    "open": "Сводка",
    "server": "Сервер",
    "ipv4": "Публичный IPv4",
    "backups": "Резервные копии",
    "times": "За один сервер, всего серверов: {{count}}",
    "total": "Итого",
    "perMonth": "{{price}} в месяц",
    "hourly": "{{price}} в час",
    "billing": "Цены без НДС, {{currency}}. Почасовая оплата с момента создания, но за месяц не больше указанного. Выключенный сервер тоже оплачивается.",
    "states": {
      "ok": "Готово",
      "warn": "Обратите внимание",
      "error": "Нужно исправить"
    },
    "totalPerMonth": "Итого в месяц"
  },
  "password": {
    "title": "Пароль root",
    "titleMany": "Пароли root",
    "lead": "SSH-ключ не выбран, поэтому провайдер сгенерировал пароль для входа: ssh root@<адрес сервера>.",
    "label": "Пароль root сервера {{name}}",
    "copy": "Скопировать пароль сервера {{name}}",
    "copied": "Пароль скопирован",
    "once": "Сохраните пароль сейчас, например в менеджере паролей. CloudServer его не хранит и показать снова не сможет; если потеряете, сбросьте пароль на странице сервера.",
    "saved": "Я сохранил пароль",
    "done": "Готово, перейти к серверу"
  },
  "backToDashboard": "Вернуться к дашборду",
  "volumes": {
    "title": "Диски",
    "intro": "Свободные диски этой локации можно подключить сразу. Они уже оплачиваются, цена сервера не меняется. Необязательно.",
    "hint": "Диск подключается к одному серверу своей локации. Новый диск создаётся на странице «Диски».",
    "none": "Без дисков",
    "line": "{{size}}\u00a0ГБ · {{format}}",
    "noFs": "без ФС",
    "empty": "В локации {{region}} нет свободных дисков.",
    "oneServer": "Диск подключается к одному серверу: уберите диски или создайте один сервер.",
    "automount": "Смонтировать автоматически",
    "automountHint": "На системах Hetzner диски с файловой системой появятся в /mnt/HC_Volume_<номер>.",
    "create": "Создать диск"
  },
  "placement": {
    "title": "Группа размещения",
    "intro": "Серверы одной группы работают на разных физических хостах. Необязательно, бесплатно.",
    "hint": "Созданный в группе сервер сразу встаёт на отдельный хост; добавить существующий сервер можно только выключенным.",
    "none": "Без группы",
    "noneHint": "Сервер встанет на любой подходящий хост.",
    "members": "Серверов: {{count}} из {{max}}",
    "full": "Нет места для ещё {{count}}",
    "create": "Создать группу"
  }
}
